'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSquareListCog, iconSquareListCogTag } from '@ni/nimble-components/dist/esm/icons/square-list-cog';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSquareListCog };
export { iconSquareListCogTag };
export const NimbleIconSquareListCog = wrap(IconSquareListCog);